<template>
  <button class="back-to-top"
          :class="buttonStyle"
          :style="{'opacity': opacity}"
          @click="scrollToTop">
    <i class="fas fa-arrow-up"></i>
  </button>
</template>

<script>
export default {
  props: {
    buttonStyle: {
      type: String,
      default: "btn btn-accent-1",
    },
    buttonVisibleAt: {
      type: Number,
      default: 20,
    },
  },
  data () {
    return {
      opacity: 0,
    };
  },
  mounted () {
    window.addEventListener( "scroll", this.onScroll );
  },
  destroyed () {
    window.removeEventListener( "scroll", this.onScroll );
  },
  methods: {
    onScroll () {
      if ( document.body.scrollTop > this.buttonVisibleAt
      || document.documentElement.scrollTop > this.buttonVisibleAt ) {
        this.opacity = 1;
      } else {
        this.opacity = 0;
      }
    },
    scrollToTop () {
      window.scrollTo( 0, 0 );
    },
  },
};
</script>

<style lang="less" scoped>
.back-to-top {
  opacity: 0;
  position: fixed;
  bottom: 20px;
  right: 30px;
  z-index: 200;
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5rem;
  transition: opacity .2s ease-out;
}
</style>
